var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,9h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3Zm10.71,11.29l-1.41,1.41-5.34-5.34-1.34,1.34-.71,.29H7.1l-.71-.29L2.29,13.61l-.29-.71V7.1l.29-.71L6.39,2.29l.71-.29h5.8l.71,.29,4.1,4.1,.29,.71v5.8l-.29,.71-1.34,1.34,5.34,5.34Zm-5.71-12.78l-3.51-3.51H7.51l-3.51,3.51v4.97l3.51,3.51h4.97l3.51-3.51V7.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchPlus);
export default __webpack_public_path__ + "static/1787821308/media/icon-search-plus.505d2ed2f565e3d490ddeb49e636b164.svg";
export { ForwardRef as ReactComponent };